import { ResultOk } from "@/types/resultok";
import { ContactUser } from "@/types/user";
import { api } from "..";
import { buildQueryString } from "./utils";

export const companyApi = api.injectEndpoints({
  endpoints: (build) => ({
    //更新内容
    updateContactUserInfo:build.mutation<ResultOk,ContactUser>({
      query: (ContactUser) => ({
        url: `/users/cooperation`,
        method: 'POST',
        body: ContactUser,
      }),
      transformErrorResponse: (baseQueryReturnValue, meta, arg) => baseQueryReturnValue.data,
    }),
  }),
});

export const { useUpdateContactUserInfoMutation } = companyApi;
